/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrintTextRequest
 */
export interface PrintTextRequest {
    /**
     * 
     * @type {string}
     * @memberof PrintTextRequest
     */
    terminalId: string;
    /**
     * 
     * @type {string}
     * @memberof PrintTextRequest
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof PrintTextRequest
     */
    serviceId?: string | null;
}

/**
 * Check if a given object implements the PrintTextRequest interface.
 */
export function instanceOfPrintTextRequest(value: object): value is PrintTextRequest {
    if (!('terminalId' in value) || value['terminalId'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function PrintTextRequestFromJSON(json: any): PrintTextRequest {
    return PrintTextRequestFromJSONTyped(json, false);
}

export function PrintTextRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrintTextRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'terminalId': json['terminalId'],
        'text': json['text'],
        'serviceId': json['serviceId'] === undefined ? undefined : json['serviceId'] === null ? null : json['serviceId'],
    };
}

export function PrintTextRequestToJSON(json: any): PrintTextRequest {
    return PrintTextRequestToJSONTyped(json, false);
}

export function PrintTextRequestToJSONTyped(value?: PrintTextRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'terminalId': value['terminalId'],
        'text': value['text'],
        'serviceId': value['serviceId'],
    };
}

